
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"205","height":"70","viewBox":"0 0 54.24 18.521"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.665 16.841c0-1.122.21-2.915.493-4.192.394-1.782 1.24-4.182 1.612-4.569.125-.13 1.487-.397 5.246-1.031 2.792-.471 5.112-.856 5.156-.856.044 0 .08 1.071.08 2.38v2.38h1.37l.028-2.512.027-2.512 3.173-.546c1.745-.3 3.203-.514 3.241-.476.039.039.085 1.415.106 3.058l.039 2.987h.82l.82.001V7.727c0-2.116.038-3.226.107-3.226.06 0 1.93-.31 4.156-.687 2.227-.378 4.082-.688 4.123-.688.041 0 .075 1.761.075 3.914v3.913h1.692V6.881c0-2.24.011-4.073.024-4.073.01 0 1.43-.238 3.147-.529 1.716-.29 3.155-.528 3.2-.528.043 0 .078 2.07.078 4.601v4.601H40.96V1.466l1.402-.23c.77-.126 1.496-.228 1.613-.226.37.006 1.808.694 2.718 1.3 1.082.72 2.51 2.145 3.417 3.408.375.523.683.985.685 1.025 0 .04.172.365.38.72.209.355.61 1.226.891 1.936a20.296 20.296 0 011.446 6.71l.067 1.402H48.045l-.002-.344c0-.19-.071-.673-.156-1.075-.325-1.535-1.19-2.82-2.221-3.303l-.53-.247H9.07l-.529.247c-1.032.483-1.896 1.768-2.221 3.303-.085.402-.156.886-.157 1.075l-.002.344h-5.5z","fill":"#f0f0f0"}})])
          )
        }
      }
    